import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = ["checked", "disabled"]

import TickIcon from '@/assets/TickIcon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    checked: { type: Boolean },
    disabled: { type: Boolean, default: false },
    text: null
  },
  emits: ["update:checked"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:checked', checked: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { checked: boolean, disabled: boolean, text?: string };






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(['checkbox__box',
      { 'checkbox__box--checked': __props.checked, 'checkbox__box--disabled': __props.disabled }])
    }, [
      _createElementVNode("input", {
        checked: __props.checked,
        class: "checkbox__input",
        type: "checkbox",
        disabled: __props.disabled,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (emits('update:checked', ($event.target as HTMLInputElement).checked)))
      }, null, 40, _hoisted_2),
      _withDirectives(_createVNode(_unref(TickIcon), { class: "checkbox__checkmark" }, null, 512), [
        [_vShow, __props.checked]
      ])
    ], 2),
    (__props.text)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['checkbox__label', { 'checkbox__label--disabled': __props.disabled }])
        }, _toDisplayString(__props.text), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})